import {matchPath, useLocation} from 'react-router-dom'

const useFrontOffice = () => {
    const { pathname } = useLocation()
    return matchPath(pathname, { path: '/fo/*'})
}
export default useFrontOffice
